import "@fontsource/titillium-web";
import "@mdi/font/css/materialdesignicons.css";
import axios from 'axios';
import "roboto-fontface/css/roboto/roboto-fontface.css";
import VeeValidate from 'vee-validate';
import it from 'vee-validate/dist/locale/it';
import Vue from "vue";
import VueAxios from 'vue-axios';
import VueLodash from 'vue-lodash';
import VueLoading from 'vuejs-loading-plugin';
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router/router";
import store from './store';

const veeValidateConfig = {
  locale: 'it',
  dictionary: {
    it
  }
}

Vue.use(VeeValidate, veeValidateConfig)
Vue.use(VueLodash)
Vue.use(VueLoading, {
  text: '',
})

axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:3000'
axios.interceptors.request.use(
    config => {
        const vuex = JSON.parse(localStorage.getItem('vuex'))
        if(vuex && vuex.token) {
            config.headers.Authorization = 'Bearer ' + vuex.token;
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

Vue.use(VueAxios, axios)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
